"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "getLogoData", {
  enumerable: true,
  get: function get() {
    return _LogoTabsData.default;
  }
});

exports.getUserMenuOptions = exports.getLinkTrackingAttr = void 0;

var _LogoTabsData = _interopRequireDefault(require("./LogoTabsData"));

var getLinkTrackingAttr = function getLinkTrackingAttr(dataLinkId) {
  var dataLinkModule = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'global-header';
  var dataLinkModuleType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'mobile-side-menu';
  var dataLinkModulePosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'none';
  var dataLinkPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '0';
  return {
    'data-link-id': dataLinkId,
    'data-link-module': dataLinkModule,
    'data-link-module-type': dataLinkModuleType,
    'data-link-module-position': dataLinkModulePosition,
    'data-link-position': dataLinkPosition
  };
};

exports.getLinkTrackingAttr = getLinkTrackingAttr;

var getUserMenuOptions = function getUserMenuOptions() {
  var brand = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'SFLY';
  return [// {
  //     key: 'my-projects',
  //     text: 'My Projects',
  //     url: '/mySavedProjects/',
  //     attr: getLinkTrackingAttr(
  //         'my-projects',
  //         'global-header',
  //         'mobile-side-menu',
  //         'none',
  //         '0',
  //     ),
  // },
  {
    key: 'my-account',
    text: 'My Account',
    url: '/myaccount/?brand=' + brand,
    hidden: false,
    attr: getLinkTrackingAttr('my-account', 'global-header', 'mobile-side-menu', 'none', '1')
  }, {
    key: 'order-history',
    text: 'Order History',
    url: '/account/orderhistory.jsp',
    attr: getLinkTrackingAttr('order-history', 'global-header', 'mobile-side-menu', 'none', '2')
  }, {
    key: 'lifetouch',
    text: 'Lifetouch',
    url: '/lifetouch-pictures/#/personalize',
    attr: getLinkTrackingAttr('lifetouch', 'global-header', 'mobile-side-menu', 'none', '3')
  }];
};

exports.getUserMenuOptions = getUserMenuOptions;